import React from "react";
import { useStepperContext } from "./StepperContext";
import { Card } from "reactstrap";

const StepperContent = ({ children, className = "" }) => {
  const { currentStep, steps } = useStepperContext();

  // Ensure we have the correct number of children for each step
  if (React.Children.count(children) !== steps.length) {
    console.warn(
      `Number of children (${React.Children.count(
        children
      )}) does not match number of steps (${steps.length})`
    );
  }

  return (
    <Card className={`border-0 shadow-sm ${className}`}>
      {React.Children.map(children, (child, index) => (
        <div
          className={`stepper-step-content ${
            currentStep === index ? "d-block" : "d-none"
          }`}
        >
          {child}
        </div>
      ))}
    </Card>
  );
};

export default StepperContent;
